import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cp-dispatch-obj-loader',
  templateUrl: './dispatch-obj-loader.component.html',
  styleUrls: ['./dispatch-obj-loader.component.scss']
})
export class DispatchObjLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
